import EntityListShell from "./EntityListShell";
import { TextField, TextAreaField, TagsField, deText } from "./fields";
import { translateFields } from "@/lib/adminContentApi";

function slugifyClient(s) {
  return (
    (s || "")
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || "service"
  );
}

function emptyForm() {
  return { key: "", icon: "Sparkles", title: "", tagline: "", description: "", stack: [] };
}

function toFormState(item) {
  return {
    key: item.key || "",
    icon: item.icon || "Sparkles",
    title: deText(item.title),
    tagline: deText(item.tagline),
    description: deText(item.description),
    stack: item.stack || [],
  };
}

async function buildPayload(form) {
  const { en = {}, fr = {} } = await translateFields({ title: form.title, tagline: form.tagline, description: form.description });
  const ml = (key, fallback) => ({ de: fallback, en: en[key] || fallback, fr: fr[key] || fallback });
  return {
    key: form.key || slugifyClient(form.title),
    icon: form.icon,
    title: ml("title", form.title),
    tagline: ml("tagline", form.tagline),
    description: ml("description", form.description),
    stack: form.stack,
  };
}

export default function ServicesEditor() {
  return (
    <EntityListShell
      collection="services"
      title="Services"
      description="Deine Leistungen auf der Dienste-Seite. Reihenfolge per Pfeiltasten änderbar."
      newLabel="Service hinzufügen"
      testidBase="svc-admin"
      emptyForm={emptyForm}
      toFormState={toFormState}
      buildPayload={buildPayload}
      renderRowSummary={(item) => (
        <div>
          <div className="text-[var(--text-0)] font-display">{deText(item.title)}</div>
          <div className="text-xs text-[var(--text-2)]">{deText(item.tagline)}</div>
        </div>
      )}
      renderFields={(form, setForm) => (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <TextField label="Titel" testid="svc-title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} required />
            <TextField
              label="Icon (lucide-react Name)"
              testid="svc-icon"
              value={form.icon}
              onChange={(v) => setForm({ ...form, icon: v })}
              placeholder="z. B. Server, Braces, Sparkles"
            />
          </div>
          <TextField label="Tagline" testid="svc-tagline" value={form.tagline} onChange={(v) => setForm({ ...form, tagline: v })} required />
          <TextAreaField
            label="Beschreibung"
            testid="svc-description"
            value={form.description}
            onChange={(v) => setForm({ ...form, description: v })}
            rows={4}
            required
          />
          <TagsField label="Tech-Stack" testid="svc-stack" value={form.stack} onChange={(v) => setForm({ ...form, stack: v })} placeholder="Java, Spring Boot" />
        </div>
      )}
    />
  );
}
